
export enum Permission {
  SHOW,
  UPDATE,
  UPDATE_VALIDITY,
  UPDATE_VALORE_ATTRIBUTO,
  DELETE,
}
